export default class Contract {}
